import inventoryService from '../services';

export const getInventoryLastUpdatedAt = async (inventoryListId) => {
  const { updatedAt } = await inventoryService.getInventoriesFromInventoriesListOfStore(
    inventoryListId,
  );

  return updatedAt;
};
